import { EBC_CLASSIC_JOURNEY as EBC_JOURNEY_BASE } from './ebcClassic';
import { EBC_GUIDED_META } from './ebcGuidedMeta';
import { EBC_DEEP_CONTENT } from './ebcDeepContent';
import { ABC_JOURNEY_BASE } from './abcClassic';
import { ABC_GUIDED_META } from './abcGuidedMeta';
import { ABC_DEEP_CONTENT } from './abcDeepContent';
import { LANGTANG_JOURNEY_BASE } from './langtangClassic';
import { LANGTANG_GUIDED_META } from './langtangGuidedMeta';
import { LANGTANG_DEEP_CONTENT } from './langtangDeepContent';
import { createJourney } from './journeyEngine';
import { TREK_CATALOG, HANDCRAFTED_SLUGS, TREK_REGIONS } from './trekCatalog';
import { generateCatalogJourneys } from './journeyFactory';

export { createJourney, enrichJourneyWithGuided, JOURNEY_PRODUCT, JOURNEY_LIFECYCLE_STEP_IDS } from './journeyEngine';
export { TREK_CATALOG, TREK_REGIONS, HANDCRAFTED_SLUGS, getCatalogByRegion } from './trekCatalog';

const HANDCRAFTED_JOURNEYS = [
	createJourney(EBC_JOURNEY_BASE, EBC_GUIDED_META, EBC_DEEP_CONTENT, { coverage: 95 }),
	createJourney(ABC_JOURNEY_BASE, ABC_GUIDED_META, ABC_DEEP_CONTENT, { coverage: 75 }),
	createJourney(LANGTANG_JOURNEY_BASE, LANGTANG_GUIDED_META, LANGTANG_DEEP_CONTENT, { coverage: 72 }),
];

const CATALOG_JOURNEYS = generateCatalogJourneys(TREK_CATALOG, HANDCRAFTED_SLUGS);

/** Hand-crafted exports (backward compatible) */
export const EBC_CLASSIC_JOURNEY = HANDCRAFTED_JOURNEYS[0];
export const ABC_JOURNEY = HANDCRAFTED_JOURNEYS[1];
export const LANGTANG_JOURNEY = HANDCRAFTED_JOURNEYS[2];

export const JOURNEY_REGISTRY = [
	...HANDCRAFTED_JOURNEYS,
	...CATALOG_JOURNEYS,
];

export const GUIDED_JOURNEY_META = {
	name: 'Guided Journey',
	tagline: 'Always know the next step — complete each task with confidence.',
	lastAudit: '2026-07-13',
	dataVersion: 'permit-registry-v1',
	journeyCount: JOURNEY_REGISTRY.length,
};

// Legacy alias
export const JOURNEY_GRAPH_META = GUIDED_JOURNEY_META;

export function getJourneyBySlug(slug) {
	return JOURNEY_REGISTRY.find((j) => j.slug === slug) || null;
}

export function getJourneysByRegion(region) {
	return JOURNEY_REGISTRY.filter((j) => j.region === region || j.district?.name?.includes(region));
}

export function getJourneyFlowSteps(journey) {
	return journey.steps.map((step) => ({
		id: step.id,
		label: step.name,
		desc: step.question,
		to: `#${step.id}`,
	}));
}
